import { StaticBaseDao } from '@/dao';
import { SetContestantStatusCancelledRequest, PostResponse } from '@/objects/generated';

export class Quick3Dao extends StaticBaseDao {
    public static async DeleteContestantOrderLinesAndSetContestantStatusToCancelled(
        EventID: number,
        requests: SetContestantStatusCancelledRequest[],
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `Quick3/DeleteContestantOrderLinesAndSetContestantStatusToCancelled` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            requests,
        );
    }
}
